import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from "./dropdown.module.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { getBooks, getLessons } from "../../../../api/requests";
import useTranslation from "next-translate/useTranslation";

var DropdownLesson = function DropdownLesson(_ref) {
  var classes = _ref.classes,
      defaultSelected = _ref.defaultSelected,
      data = _ref.data,
      setSelectedLesson = _ref.setSelectedLesson,
      selectedLesson = _ref.selectedLesson,
      setShow = _ref.setShow,
      setError = _ref.setError,
      setSelectedTopic = _ref.setSelectedTopic;

  var _useState = useState(false),
      dropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var toggle = function toggle() {
    var Username = localStorage.getItem('Username');
    var token = localStorage.getItem('token');

    if (Username && token) {
      setDropdownOpen(function (prevState) {
        return !prevState;
      });
    } else {
      setError(["login", false]);
      setShow(true);
    }
  };

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  useEffect(function () {
    setSelectedLesson({
      lessonId: null,
      name: isRTL ? defaultSelected.fa : defaultSelected.en
    });
  }, [isRTL]);

  var handleSelect = function handleSelect(selectedItem) {
    setSelectedTopic(null);
    setSelectedLesson({
      name: selectedItem.item.LessonName,
      LessonId: selectedItem.item.LessonId
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Dropdown, {
        className: "".concat(styles.menuItem, " ").concat(classes.bg),
        isOpen: dropdownOpen,
        toggle: toggle,
        children: [/*#__PURE__*/_jsx("div", {
          className: classes.arrow
        }), /*#__PURE__*/_jsx(DropdownToggle, {
          caret: true,
          children: selectedLesson.name
        }), /*#__PURE__*/_jsx(DropdownMenu, {
          children: data && data.length > 0 ? data.map(function (item, index) {
            return /*#__PURE__*/_jsx(DropdownItem, {
              onClick: function onClick() {
                return handleSelect({
                  item: item,
                  id: index + 1
                });
              },
              children: item.LessonName
            }, index);
          }) : /*#__PURE__*/_jsx(DropdownItem, {
            children: isRTL ? 'یک کتاب انتخاب کنید' : 'Choose a Book'
          })
        })]
      })
    })
  });
};

export default DropdownLesson;